/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  clientDataType,
  getGuarantorsType,
} from '@/services/pre-enrollment/types';

const setInitialValues = (formik: any) => {
  formik.setValues(
    {
      ...formik.values,
      zipcode: '',
      state: '',
      city: '',
      neighborhood: '',
      address: '',
      residence_type: '',
      residence_number: '',
      address_complement: '',
    },
    false,
  );
};

const setCandidateAddress = async (formik: any, clientData: clientDataType) => {
  await formik.setFieldTouched('address_complement', true);
  formik.setTouched((v: any) => ({
    ...v,
    zipcode: true,
    state: true,
    city: true,
    neighborhood: true,
    address: true,
    residence_type: true,
    residence_number: true,
    address_complement: true,
  }));
  formik.setValues((v: any) => ({
    ...v,
    zipcode: clientData.zipcode,
    state: clientData.state,
    city: clientData.city,
    neighborhood: clientData.neighborhood,
    address: clientData.address,
    residence_type: clientData.residence_type,
    residence_number: clientData.residence_number,
    address_complement: clientData.address_complement,
  }));
};

const setFirstGuarantorPersonAddress = async (
  formik: any,
  firstGuarantor: getGuarantorsType,
) => {
  await formik.setFieldTouched('address_complement', true);
  formik.setTouched((v: any) => ({
    ...v,
    zipcode: true,
    state: true,
    city: true,
    neighborhood: true,
    address: true,
    residence_type: true,
    residence_number: true,
    address_complement: true,
  }));
  formik.setValues((v: any) => ({
    ...v,
    zipcode: firstGuarantor?.zipcode,
    state: firstGuarantor?.state,
    city: firstGuarantor?.city,
    neighborhood: firstGuarantor?.neighborhood,
    address: firstGuarantor?.address,
    residence_type: firstGuarantor?.residence_type,
    residence_number: firstGuarantor?.residence_number,
    address_complement: firstGuarantor?.address_complement,
  }));
};

export {
  setCandidateAddress,
  setInitialValues,
  setFirstGuarantorPersonAddress,
};
